<div class="form-container" id="perimetres_form" appearance="outlined" data-tfa="perimetres-form">
    <mat-card-title>
        <h2>Périmètres d'habilitation</h2>
    </mat-card-title>
    <mat-card-content>
        @if (!!(mesPerimetres$ | async)?.length) {
        <mat-form-field style="width: 100%;">
            <mat-label>Périmètres</mat-label>
            <mat-chip-grid #chipGrid aria-label="Ajouter un périmètre">
                @for (perimetreCode of perimetresEnLectureSeule; track perimetreCode) {
                <mat-chip-row
                    [aria-description]="'périmètre ' + perimetreCode"
                    [attr.data-tfa]="'chip-code-perimetre-non-modifiable_' + perimetreCode"
                    class="perimetre-non-modifiable"
                    matTooltip="Périmètre non associé à cet utilisateur"
                    disableRipple="true"
                    >{{ perimetreCode }}</mat-chip-row
                >
                } @for (perimetre of selectedPerimetres; track perimetre) {
                <mat-chip-row
                    (removed)="remove(perimetre)"
                    [editable]="false"
                    [aria-description]="'périmètre ' + perimetre.code + ' ' + perimetre.libelle"
                    (click)="$event.stopImmediatePropagation()"
                >
                    {{ perimetre.code }} {{ perimetre.libelle }}
                    @if (!readonly) {
                    <button
                        matChipRemove
                        [attr.aria-label]="'retirer le périmètre' + perimetre.code"
                        [attr.data-tfa]="'chip_' + perimetre"
                        [matTooltip]="'retirer ce périmètre'"
                        (click)="$event.stopImmediatePropagation()"
                    >
                        <mat-icon [attr.data-tfa]="'icon-remove_' + perimetre">cancel</mat-icon>
                    </button>
                    }
                </mat-chip-row>
                }
                <input
                    #perimetresInput
                    [matChipInputFor]="chipGrid"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    (matChipInputTokenEnd)="add($event)"
                    [formControl]="form"
                    [matAutocomplete]="auto"
                    matInput
                    [placeholder]="
                        (perimetresAjoutables$ | async)?.length === 0
                            ? 'La formation est déjà associée à tous vos périmètres.'
                            : 'Rechercher un périmètre...'
                    "
                    data-tfa="input-perimetre"
                    [disabled]="readonly"
                />
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)" [hideSingleSelectionIndicator]="true">
                    @for (perimetre of perimetresAjoutables$ | async; track perimetre) {
                    <mat-option [value]="perimetre" [attr.data-tfa]="'option-perimetre_' + perimetre.code">
                        {{ perimetre.code }} {{ perimetre.libelle }}
                    </mat-option>
                    }
                </mat-autocomplete>
            </mat-chip-grid>
        </mat-form-field>
        <div class="buttons-horizontal-container">
            <ng-content select="#bouton-fermer-perimetres"></ng-content>
            @if (!readonly) {
            <button
                data-tfa="bouton-enregistrer-perimetres"
                mat-raised-button
                color="primary"
                [disabled]="form.pristine || form.invalid"
                (click)="enregistrerHandler()"
            >
                Enregistrer
                <mat-icon data-tfa="icon-check">check</mat-icon>
            </button>
            }
        </div>
        }
    </mat-card-content>
</div>
